/* istanbul ignore file */
import styled from 'styled-components';
import { Paragraph } from '@econsult/econsult-ui/dist/components/shared/typography';
import { Divider as D } from '@econsult/econsult-ui/dist/components/shared/divider';
import { Toggle } from '@econsult/econsult-ui/dist/components/Toggle';
import { ColumnDiv } from 'components/Div/styles';

export const SnomedContainer = styled(ColumnDiv)`
  display: flex;
  width: 400px;
  position: sticky;
  top: 0;
  overflow-y: hidden;
  background-color: ${({ theme }) => theme.colorPrimaryPrimary100};
  color: ${({ theme }) => theme.colorNeutralBrightWhite};
  border-left: 1px solid ${({ theme }) => theme.colorNeutralNeutral2};
  border-top: 1px solid ${({ theme }) => theme.colorNeutralNeutral2};
  padding: 16px;
`;

export const SnomedHeader = styled(Paragraph).attrs({ typography: 'ParagraphSmallHeavy' })`
  margin: 16px 32px;
`;

export const Divider = styled(D)`
  border-color: ${({ theme }) => theme.colorNeutralNeutral2};
  border-width: 1px;
  margin-top: 16px;
`;

export const Header = styled(Paragraph).attrs({ typography: 'ParagraphSmallHeavy' })`
  margin-top: 8px;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Label = styled.label`
  margin-bottom: 4px;
  font-size: 14px;
`;

export const InputWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const StyledInput = styled.input<{ hasError?: boolean }>`
  padding: 8px;
  border: solid 2px ${({ hasError, theme }) => (hasError ? '#d32f2f' : theme.colorNeutralNeutral2)};
  border-radius: 4px;
  width: 14ch;
  box-sizing: border-box;

  /* Chrome, Safari, Edge */
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    appearance: none;
    margin: 0;
  }

  /* Firefox */
  &[type='number'] {
    appearance: textfield;
  }
`;

export const StyledSelect = styled.select`
  padding: 8px 24px 8px 8px;
  border: solid 2px ${({ theme }) => theme.colorNeutralNeutral2};
  border-radius: 4px;
  width: 80%;
  box-sizing: border-box;
`;

export const Unit = styled.span`
  margin-left: 8px;
  white-space: nowrap;
  font-size: 16px;
  align-self: end;
`;

export const ErrorText = styled.div`
  min-height: 1em;
  margin-top: 4px;
  font-size: 0.875rem;
  line-height: 1em;
  color: #D32F2F;
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px;
`;

export const SnomedListWrapper = styled.div`
  flex: 1;
  overflow-y: auto;
  margin-top: 8px;
`;

export const SnomedListItemContainer = styled.div<{ isAiSnomed?: boolean }>`
  min-height: 30px;
  border-radius: 6px;
  align-items: center;
  margin: 0 0 4px 0;
  padding: 8px;
  position: relative;
  z-index: 0;

  ${({ theme, isAiSnomed }) => (
    isAiSnomed
      ? `
        background:
          linear-gradient(${theme.colorNeutralNeutral9}, ${theme.colorNeutralNeutral9}) padding-box,
          linear-gradient(306.27deg, #729DFF 3.06%, #78CCD5 38.05%, #FFAAD6 68.09%, #FFB64A 98.42%) border-box;
        border: 2px solid transparent;
        background-origin: border-box;
        background-clip: padding-box, border-box;
        border-radius: 6px;
      `
      : `
        background-color: ${theme.colorNeutralNeutral9};
        border: 2px solid transparent;
        border-radius: 6px;
      `
  )}
`;

export const SnomedToggle = styled(Toggle)`
  display: inline-block;
  margin: 0 8px 0 0;
  vertical-align: middle;
`;

export const SnomedData = styled.span.attrs({ typography: 'ParagraphTinyHeavy' })`
  font-weight: ${({ theme }) => theme.fontWeight600};
  color: ${({ theme }) => theme.colorNeutralNeutral1};
  font-size: 12px;
  margin-right: 4px;
  margin-left: 4px;
`;
